export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-29T13:15:33",
  lastPipeline: "6624",
  version: "0.0.0",
  sentryDsn: '',
};
